export default "__VITE_ASSET__f098a847__"